import { Component, OnInit }  from '@angular/core';
import { Auth }       from './services/auth.service';
import { AdminService }       from './services/admins/admin.service';
import { Authorized }       from './services/activators/authorized.service';
import { Admin }       from './classes/admin';
import {
    Router,
    Event as RouterEvent,
    NavigationStart,
    NavigationEnd,
    NavigationCancel,
    NavigationError }       from '@angular/router';
import { SpinnerComponent } from './spinner/spinner.component'
import { SpinnerService } from './spinner.service';

import * as _ from 'lodash';
import { RequestService } from './services/request.service';


@Component({
  moduleId: module.id,
  selector: 'my-app',
  templateUrl: 'app.component.html',
  styleUrls: [ 'app.component.css' ]
})

export class AppComponent implements OnInit{
  user:Admin
  authorized:boolean=false //por ahora
  title = 'Llamando al Doctor - Backoffice';

  isMobile:boolean;

  constructor(private auth: Auth, private router: Router, private adminService:AdminService, public spinner: SpinnerService, private rest:RequestService) {
    //this.checkMobile()

    router.events.subscribe((event: RouterEvent) => {
     // this._navigationInterceptor(event);
    });
  }

  ngOnInit(){
    this.checkAdmin();
  }

  // Shows and hides the loading spinner during RouterEvent changes
  private _navigationInterceptor(event: RouterEvent): void {
    console.log(event);
    if (event instanceof NavigationStart) {
      this.spinner.start();
    }
    if (event instanceof NavigationEnd) {
      this.spinner.stop();
    }

    // Set loading state to false in both of the below events to
    // hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.spinner.start();
    }
    if (event instanceof NavigationError) {
      this.spinner.start();
    }
  }

  checkMobile(){
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (this.isMobile) {
      console.log("mobile")
    }

  }

  checkAdmin(){
    this.authorized = this.auth.isAdmin()
    if (this.auth.authenticated() && this.auth.shouldFetchAdmin()){
      this.adminService.getMe().then(user => {
        if (user.type==2){
          this.authorized=true;
          this.auth.putAdmin(user);
        } else {
          this.auth.logout()
          alert("Not allowed")
        }
      })
    }
  }

  hasReportsPermission() {
    return this.auth.hasReportsPermission();
  }

  hasSysOpsPermission() {
    return this.auth.hasSysOpsPermission();
  }

  hasPatientValidationPermission() {
    return this.auth.hasPatientValidationPermission();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts